import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IStepOption, TourService } from 'ngx-ui-tour-md-menu';

import type { FeatureTourStepContent, TutorialMedia } from './tours/tour.types';

type TourStepWithMedia = IStepOption & { media?: TutorialMedia; richContent?: FeatureTourStepContent };

@Component({
  selector: 'app-tour-step-template',
  standalone: false,
  templateUrl: './tour-step-template.component.html',
  styleUrls: ['./tour-step-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourStepTemplateComponent implements OnDestroy {
  isTocOpen = false;

  private stepSubscription: Subscription;
  private tourEndSubscription: Subscription;

  constructor(public readonly tourService: TourService<TourStepWithMedia>) {
    this.stepSubscription = this.tourService.stepShow$.subscribe(() => {
      this.isTocOpen = false;
    });

    this.tourEndSubscription = this.tourService.end$.subscribe(() => {
      this.isTocOpen = false;
    });
  }

  toggleToc(): void {
    this.isTocOpen = !this.isTocOpen;
  }

  onToggleToc(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.toggleToc();
  }

  onSelectStep(event: MouseEvent, stepIndex: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.isTocOpen = false;
    this.tourService.goto(stepIndex);
  }

  trackStep(index: number): number {
    return index;
  }

  asRichContent(step: TourStepWithMedia): FeatureTourStepContent | undefined {
    return step.richContent;
  }

  ngOnDestroy(): void {
    this.stepSubscription.unsubscribe();
    this.tourEndSubscription.unsubscribe();
  }
}
